const consulta_de_retrato_de_matricula_do_censo = [
  {
    path: "/consulta-de-retrato-de-matricula-do-censo",
    name: "consulta_de_retrato_de_matricula_do_censo",
    meta: {
      breadCrumb: "Censo Escolar - Retrato para o Censo",
      allowedPermissions: ["retrato_matricula_listar_por_escola"],
    },
    component: () =>
      import(
        "@/views/ConsultaDeRetratoDeMatriculaDoCenso/ConsultaDeRetratoDeMatriculaDoCenso.vue"
      ),
  },
];

export { consulta_de_retrato_de_matricula_do_censo };
